'use strict';
import Vue from 'vue';
import Vuex from 'vuex';

import contractModule from './store/contract';
import marketingPermissionsModule from './store/marketingPermissionsModule';
import App from './components/Contract/Contract';
import ContractModal from './components/Contract/ContractModal';
import MarketingPermissions from './components/Contract/MarketingPermissions';

var store = new Vuex.Store({
	modules: {
		contractModule,
		marketingPermissionsModule
	}
});

if (document.getElementById('contractModal')) {
	new Vue({
		name: 'ContractM',
		el: '#contractModal',
		template: '	<ContractModal />',
		store,
		components: {
			ContractModal
		}
	});
}

if (document.getElementById('contract')) {
	new Vue({
		name: 'Contract',
		el: '#contract',
		template: '	<App />',
		store,
		components: {
			App
		}
	});
}

if (document.getElementById('marketingPermissions')) {
	new Vue({
		name: 'MarketingPermissions',
		el: '#marketingPermissions',
		template: '	<MarketingPermissions />',
		store,
		components: {
			MarketingPermissions
		}
	});
}
